import { DetailsAddress } from '../types';

export const formatAddressName = ({ firstName, lastName }: DetailsAddress) =>
  `${firstName} ${lastName}`.trim();

export const formatAddressStreet = ({
  addressLine1,
  addressLine2,
}: DetailsAddress) => [addressLine1, addressLine2].filter(Boolean).join(', ');

export const formatAddressLocality = ({
  city,
  countryName,
  zip,
}: DetailsAddress) => `${zip.toLocaleUpperCase()} ${city}, ${countryName}`;

export const formatMaskedCardNumber = (last4: string) =>
  `∙∙∙∙ ∙∙∙∙ ∙∙∙∙ ${last4}`;
